import { Controller } from "@hotwired/stimulus"

// The Website Edit workspace: the collapsible v0 chat panel, and a preview
// that follows the newest version as the change-request thread reloads.
export default class extends Controller {
  static targets = ["expand", "panel", "preview", "previewLink", "scroller", "version"]

  connect() {
    this.stuckToBottom = true
    this.scrollToBottom()
  }

  collapse() {
    this.panelTarget.classList.add("hidden")
    this.expandTargets.forEach((el) => el.classList.remove("hidden"))
  }

  expand() {
    this.panelTarget.classList.remove("hidden")
    this.expandTargets.forEach((el) => el.classList.add("hidden"))
    this.scrollToBottom()
  }

  // Keeps the thread pinned to its newest message unless the reader has
  // scrolled up to read older ones.
  scrolled() {
    const el = this.scrollerTarget
    this.stuckToBottom = el.scrollHeight - el.scrollTop - el.clientHeight < 80
  }

  // Swapping the iframe's src reloads the preview, so it only changes when
  // the reloaded thread names a different version.
  threadLoaded() {
    const { previewUrl, version } = this.element.querySelector("[data-preview-url]")?.dataset ?? {}
    if (previewUrl) {
      if (this.hasPreviewTarget && this.previewTarget.getAttribute("src") !== previewUrl) this.previewTarget.setAttribute("src", previewUrl)
      this.previewLinkTargets.forEach((el) => el.setAttribute("href", previewUrl))
    }
    if (version && this.hasVersionTarget) this.versionTarget.firstElementChild.textContent = `Latest draft · ${version}`
    if (this.stuckToBottom) this.scrollToBottom()
  }

  scrollToBottom() {
    if (this.hasScrollerTarget) this.scrollerTarget.scrollTop = this.scrollerTarget.scrollHeight
  }
}
